__turbopack_context__.v({
  "burger": "Header-module-scss-module__nSCgKG__burger",
  "logos": "Header-module-scss-module__nSCgKG__logos",
  "root": "Header-module-scss-module__nSCgKG__root",
  "santa": "Header-module-scss-module__nSCgKG__santa",
  "workspaceLogo": "Header-module-scss-module__nSCgKG__workspaceLogo",
});
